<template>
  <div class="contatiner">
    <div class="title">小白考研售后服务</div>
    <div class="box">
      <div class="label">请选择购买的产品</div>
      <div class="block block1" @click="choose($event, '1')">
        <div class="type type1">调剂信息服务</div>
        <div class="btn type1">选择</div>
      </div>
      <div class="block block2" @click="choose($event, '2')">
        <div class="type type2">复试口语模板</div>
        <div  class="btn type2">选择</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, Field, Image, Loading, Button, Notify, NoticeBar, Grid, GridItem, Icon } from 'vant';

export default {
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [NoticeBar.name]: NoticeBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon
  },
  data () {
    return {
     
    };
  },
  created () {

  },
  methods: {
    choose(e, type) {
      // console.log(this.$router)
      this.$router.push({ path: type == 1? 'tj-query' : 'order-query'})
    },
  }
};
</script>

<style scoped lang="less">
  .contatiner{
    .title{
      padding-top: 42px;
      padding-bottom: 30px;
      text-align: center;
      font-size: 36px;
      color: #333333;
    }
    .box{
      margin: 0 15px;
      padding: 32px 0;
      background:#FFFFFF;
      box-shadow:0px 0px 15px 0px rgba(0,0,0,0.1);
      border-radius:18px;
      .label{
        text-align: center;
        font-size: 18px;
        color: #333333;
      }
      .block{
        width:310px;
        margin: 0 auto;
        margin-top: 22px;
        padding-bottom: 15px;
        border-radius:10px;
        .type{
          padding-top: 25px;
          text-align: center;
          font-size: 19px;
        }
        .btn{
          width:86px;
          height:30px;
          margin: 0 auto;
          margin-top: 35px;
          line-height: 30px;
          text-align: center;
          border-radius:33px;
          border: 1px solid #ffffff;
        }
      }
      .block1{
        background:linear-gradient(181deg,rgba(244,250,255,1) 0%,rgba(232,242,255,1) 100%);
        .type1{
          color: #2F80FB;
          border-color: #2F80FB;
        }
      }
      .block2{
        background:linear-gradient(180deg,rgba(255,250,244,1) 0%,rgba(255,243,232,1) 100%);
        .type2{
          color: #FB982F;
          border-color: #FB982F;
        }
      }
    }
  }
</style>
